import { styled } from '@uhg-abyss/web/tools/styled';
import { Button } from '@uhg-abyss/web/ui/Button';
import { DropdownMenu } from '@uhg-abyss/web/ui/DropdownMenu';
import { Link } from '@uhg-abyss/web/ui/Link';
import { SearchInput } from '@uhg-abyss/web/ui/SearchInput';

export const ContainerForPlanSelection = styled('div', {
  margin: '24px 0px',
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
});

export const ContainerForMultiplePlans = styled('div', {
  paddingTop: '24px',
  paddingBottom: '24px',
  margin: '0px 8px',
  '@media (max-width: 464px)': {
    margin: '0px',
  },
});

export const StyledContainerforPage = styled('div', {});

export const PlanNameLink = styled(Link, {
  textAlign: 'start',
  padding: 0,
  width: 'fit-content',
  '&.abyss-link-root': {
    alignItems: 'center',
    display: 'inline-flex',
    lineHeight: '18px',
  },
  '.abyss-link-icon-wrapper': {
    verticalAlign: 'text-top',
    '.abyss-link-icon': {
      'font-size': '16px',
    },
  },
});

export const StyledFundedHealthButton = styled(Button, {
  '&.abyss-button-root': {
    marginTop: '0px',
    width: '209px',
    letterSpacing: '0px',
    border: '0px',
    outline: '1px solid #ccc',
    borderRadius: '100px',
    padding: '8px 16px',
    cursor: 'default',
    fontWeight: '600 !important',
    lineHeight: '20px !important',
    minHeight: '40px',
    height: 'auto',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    '&:active, &:hover': {
      color: 'white !important',
      border: 'none',
      backgroundColor: '$core.color.brand.100',
    },
  },
});

export const StyledDropdownMenu = styled(DropdownMenu, {
  '&.abyss-dropdown-menu-root': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #929496',
    borderRadius: '500px',
    backgroundColor: '#FFFFFF',
    color: '#323333',
    height: '22px',
    gap: '8px',
    padding: '8px 16px',
  },
  '&.abyss-insert-element-root': {
    gap: '5px',
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: '20px',
  },
});

export const StyledCategoryContainer = styled('div', {});
export const StyledListOfCategoryContainer = styled('div', {
  marginBottom: '16px',
  border: 'none',
  borderRadius: '100px',
  padding: '10px 16px',
  color: '#4B4D4F',
  background: '#F2F2F2',
  width: 'fit-content',
  justifyContent: 'center',
  fontWeight: '700',
  fontStyle: 'Bold',
  fontSize: '14px',
  lineHeight: '18px',
  letterSpacing: '0%',
  textAlign: 'center',
});

export const StyledText = {
  lineHeight: '18px',
  fontWeight: '500',
  fontSize: '14px',
};

export const ContainerPlanNamesFlex = styled('ul', {
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  '@media (max-width: 744px)': {
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
  },
  gridTemplateRows: 'none',
  gap: '16px 24px',
  paddingLeft: '16px',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  margin: '0px',
  listStyle: 'none',
});

export const SearchInputContainer = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const StyledTextForNoResults = {
  '&.abyss-text-root': {
    fontSize: '16px !important',
    fontWeight: '500 !important',
    lineHeight: '20px !important',
    color: '#323333 !important',
  },
};

export const planLabel = {
  paddingLeft: '2px',
  fontSize: '$sm',
  color: '$core.color.neutral.90',
  lineHeight: '18px',
  fontWeight: '700',
};

export const StyledPlanSearch = styled(SearchInput, {
  border: 'none !important',
  '.abyss-search-input': {
    boxShadow: 'none',
    border: 'none',
    fontSize: '18px !important',
    color: '#4B4D4F',
    fontWeight: '400',
    padding: '0px 0px 0px 2px !important',
    minHeight: '24px !important',
  },
  '&:focus, &:focus-within': {
    boxShadow: 'none !important',
    outline: 'none !important',
  },
  '&.abyss-search-input-root': {
    border: '1px solid',
    borderRadius: '4px',
  },
  '.abyss-search-input-input-container': {
    alignItems: 'left',
    border: 'none',
  },
  '.abyss-search-input-section': {
    backgroundColor: 'white',
    color: '$core.color.neutral.60',
    fontWeight: '$medium',
  },
  '.abyss-search-input-icon-container': {
    display: 'none',
  },
  '.abyss-search-input-option-icon': {
    display: 'none',
  },
  '.abyss-search-input-right-element-wrapper': {
    height: '24px !important',
    width: '24px !important',
    display: 'absolute',
  },
  '.abyss-search-input-right-element': {
    position: 'relative',
    top: '-12px',
    height: '24px !important',
    width: '24px !important',
  },
  '.abyss-search-input-left-element': {
    display: 'none',
  },
  '.abyss-search-input-left-element-wrapper': {
    display: 'none',
  },
  '&.abyss-search-input-option-list': {
    border: '1px solid $core.color.neutral.30',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.12)',
  },
  '&.abyss-search-input-option-list:has(> .abyss-search-input-no-options)': {
    border: 'none',
    boxShadow: 'none',
    display: 'none',
  },
});

export const PlanInputContainer = styled('div', {
  flexWrap: 'nowrap',
  height: '62px',
  margin: '12px 0px',
  border: '1px solid #CBCCCD',
  borderRadius: '50px',
  padding: '8px 24px',
  alignContent: 'center',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  minWidth: '420px',
  width: '62.5%',
  '@media (max-width: 744px)': {
    width: '80%',
    minWidth: '320px',
  },
  '@media (max-width: 464px)': {
    width: '100%',
    minWidth: '100px',
    paddingRight: '10px',
    paddingLeft: '10px',
    '.abyss-search-input-root': {
      minWidth: '150px',
    },
  },
  '.abyss-search-input-root': {
    height: '24px',
  },
  '.abyss-search-input-input': {
    height: '24px',
    background: 'transparent',
    paddingRight: '5px',
  },
  '.abyss-search-input-label': {
    marginTop: '-4px',
    marginBottom: '-8px',
    lineHeight: '18px',
    fontSize: '$sm',
    fontWeight: 'bold',
  },
});

export const toastErrorStyle = {
  'abyss-toast-description': {
    lineHeight: '20px !important',
    marginRight: '11px !important',
  },
  'abyss-toast-close-button': {
    marginTop: '8px',
  },
};
